import axios from 'axios';
import { useAsync } from 'react-use';

import { getAuthToken } from '@providers/AuthProvider';
import { ApiEndpoints } from '@utils/endpoints';

const useDeliveryMethod = () => {
	const state = useAsync(async () => {
		const authorizationToken = await getAuthToken();

		const response = await axios.get<{ deliveryMethod: string }>(`${ApiEndpoints.deliveryMethod}`, {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				authorizationToken,
			},
		});

		if (!response.data) return;
		return response.data.deliveryMethod;
	});

	return state;
};

export default useDeliveryMethod;
